<template>
    <div :class="$style['select-for-detection']">
        <pt-page-search label="检测项名称：" :searchKey="searchKey" @search="search" @emptySearch="emptySearch" placeholder="请输入检测项名称"></pt-page-search>
        <pt-page-menu-filter  :isRouteQuery="false" :tabs="tabs" v-model="selectTab" :class="$style['detetion-page-menu-filter']"></pt-page-menu-filter>
         <pt-select-list :page-size="pageSize" :tableLabels="tableLabels"  @getTableData="getTableData" :total-count="totalCount" :table-data="tableData"  @selected="selected"
         :loading="loading" :selectedRows="selectRow" :isSelect="isSelect" ref="table" >
        <slot slot="before" name="before"/>
        </pt-select-list>
        <div class="button-div">
            <el-button type="primary" @click="submit">选择</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import { detectionTags, tagsTableLabels } from './mall-options.js'
export default {
  props: {
    selectDetetion: {
      type: [Array, Object],
      default: function () {
        return null
      }
    },
    selectDetectionTab: {
      type: String,
      default: 'all'
    }
  },
  data () {
    return {
      tabs: detectionTags,
      tableLabels: tagsTableLabels,
      selectTab: this.selectDetectionTab,
      pageSize: 8,
      totalCount: 0,
      tableData: [],
      isSelect: true,
      loading: false,
      selectRow: JSON.parse(JSON.stringify(this.selectDetetion)),
      searchKey: null
    }
  },
  watch: {
    selectTab (val) {
      this.$refs.table.reset()
      this.getTableData(0)
    }
  },
  methods: {
    search (val) {
      this.searchKey = val
      this.getTableData(0)
    },
    emptySearch () {
      this.searchKey = null
      this.getTableData(0)
    },
    selected (val) {
      this.selectRow = JSON.parse(JSON.stringify(val))
      this.$emit('selectMealRow', val)
    },
    getTableData (page, next) {
      let data = {
        chineseName: this.searchKey || null,
        category: this.selectTab === 'all' ? null : this.selectTab,
        page: page,
        size: this.pageSize,
        getAllConfigs: true,
        getCorpus: false
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getDetectionListByFilter', data).then(res => {
        this.tableData = res.data
        this.totalCount = res.totalNumber
        this.loading = false
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取检测项列表失败')
      })
    },
    submit () {
      this.$emit('selectDetectionSubmit', JSON.parse(JSON.stringify(this.selectRow)))
    },
    cancel () {
      this.$emit('close')
    }
  },
  created () {
  }
}
</script>
<style module lang="less">
.select-for-detection{

}
.detetion-page-menu-filter{
    margin-top: 20px;
}
</style>
